module.exports = __webpack_public_path__ + "images/backgrounds/river/large.801d937c765a9996d4ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/river/large.jpg
// module id = Hxxw
// module chunks = 0